import request from '@/utils/request';
export const defaultAdminRoleData = {
  id: 0,
  enabled: true,
  name: ''
};
export const getRoles = params => request({
  url: '/admins-roles',
  method: 'get',
  params
});
export const getRoleById = id => request({
  url: `/admins-roles/${id}`,
  method: 'get'
});
export const updateRole = (id, data) => request({
  url: `/admins-roles/${id}`,
  method: 'patch',
  data
});
export const deleteRole = id => request({
  url: `/admins-roles/${id}`,
  method: 'delete'
});
export const createRole = data => request({
  url: '/admins-roles/',
  method: 'post',
  data
});
export const getRoutes = params => request({
  url: '/routes',
  method: 'get',
  params
});